import React from "react";
import styled from "styled-components";

const Title = styled.div`
    width: 100%;
    height: 15vh;
    background-color: #453D24;
    color: white;
    font-family: "Inter", sans-serif;
    font-size: 36px;
    font-style: normal;
    font-weight: 600; /* Semi-bold */
    display: flex; /* Use flexbox */
    align-items: center; /* Center items vertically */
    justify-content: center; /* Center items horizontally */
`;

// mobile card for 30 columns
//4 11 18 25 do oppo
const Card30 = ({ image, color, article_title, article_byline, direction }) => (
    <StyledCard30 direction={direction}>
        {direction === "right" ? (
            <>
                <LeftBox image={image} />
                <RightBox color={color}>
                    <TextContainer>
                        <BoldText>{article_title}</BoldText>
                        <br />
                        <br />
                        <BylineText>By {article_byline}</BylineText>
                    </TextContainer>
                </RightBox>
            </>
        ) : (
            <>
                <RightBox color={color}>
                    <TextContainer>
                        <BoldText>{article_title}</BoldText>
                        <br />
                        <br />
                        <BylineText>By {article_byline}</BylineText>
                    </TextContainer>
                </RightBox>
                <LeftBox image={image} />
            </>
        )}
    </StyledCard30>
);

const StyledCard30 = styled.div`
    display: grid;
    grid-template-columns: 50% 50%;
    height: 25vh;
    width: 100%;
    direction: ${props => (props.direction === "left" ? "row" : "row-reverse")};
`;

const LeftBox = styled.div`
    background-image: url(${props => props.image});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    height: 100%;
    width: 100%;
`;

const RightBox = styled.div`
    font-family: "Oswald", sans-serif;
    font-weight: 500;
    font-style: normal;
    color: black;
    font-size: 12px;
    display: grid;
    place-items: center;
    align-items: flex-start; /* Align items to the left */
    justify-content: center; /* Center items vertically */
    background-color: ${props => props.color || "blue"}; /* Use color prop or default to blue */
    white-space: pre-line; /* Allow newline characters in content */
    padding: 20px; /* Add padding to ensure content is not too close to the edge */
    text-align: left; /* Ensure text is left-aligned */
`;

const TextContainer = styled.div`
    width: 100%; /* Ensure the text container takes full width */
    text-align: left; /* Align text within the container to the left */
`;

const BoldText = styled.b`
    font-size: 13px; /* Different font size for bold text */
    margin-bottom: 10px; /* Space between the title and the byline */
    line-height: 1.2; /* Adjust line height for better spacing */
    display: block; /* Ensure block-level behavior */
`;

const BylineText = styled.span`
    font-size: 12px; /* Regular font size for byline text */
    margin-top: 5px; /* Space above the byline text */
    display: block; /* Ensure block-level behavior */
`;

const Container = styled.div`
    margin: 0 auto;
    position: relative;
    height: auto;
    padding: 0;
    width: 100%;
    box-sizing: border-box; /* Include padding and border in the element's total width and height */
`;

const Grid = styled.div`
    margin-top: 0px;
    display: grid;
    grid-template-columns: 1fr; /* Single column */
    justify-items: center;
    align-items: center;
    gap: 0px;
    width: 100%;
`;

const Mobile30 = (props) => {
    let direction = 1; // start with right
    let counter = -2;
    
    return (
        <>
            <Title>-30- COLUMNS</Title>
            <Container>
                <Grid>
                    {props && props.thirty ? props.thirty.map((item, index) => {
                        direction = !direction; // toggle direction
                        counter += 1;

                        if ((counter - 3 ) % 7 === 0) {  //4 11 18 or 25
                            direction = !direction; // toggle direction
                        }
                        return (
                            <Card30
                                key={index}
                                image={item.article_image}
                                color={item.color}
                                article_title={item.article_title}
                                article_byline={item.article_byline}
                                direction={direction ? "left" : "right"}
                            />
                        );
                    }) : null}
                </Grid>
            </Container>
        </>
    );
}

export default Mobile30;
